export const BACKEND_ENDPOINT = "https://api.score.idjshow.com/";

// Authentication URLS
export const ACCESS_TOKEN_URL = BACKEND_ENDPOINT + "token/";
export const REFRESH_TOKEN_URL = BACKEND_ENDPOINT + "token/refresh/";

// Score URL
export const SCORE_URL = "score/"

// Artist URLs
export const ARTISTS_URL = "artists/"

// Weekly URLs
export const WEEKLY_URLS_URL = "weekly_urls/"
export const ALL_URL_TYPES_URL = "all_url_types/"
export const ALL_ARTISTS_URL = "all_artists/"